// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-10-15 17:58:04 +0200 (Wed, 15 Oct 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 157243 $
//  Purpose   : scidesk support
// =============================================================================
export const parts = true

import * as views from './views'
export {views}
